// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__WeNOR","large":"styles_large__2_t13"};